const FIVE_MILES_IN_METERS = 8046.72;

const getAddress = ({ address_components, formatted_address }) => {
  const route = getAddressComponentByType(address_components, 'route');
  const streetNumber = getAddressComponentByType(address_components, 'street_number');
  const city = getAddressComponentByType(address_components, ['locality', 'sublocality_level_1']);
  const state = getAddressComponentByType(address_components, 'administrative_area_level_1');
  const zip = getAddressComponentByType(address_components, 'postal_code');

  return {
    address: streetNumber ? `${streetNumber} ${route}` : route,
    city,
    full_address: formatted_address,
    state,
    zip,
  };
};

const getAddressComponentByType = (addressComponents, type) => {
  const types = Array.isArray(type) ? type : [type];
  for (const t of types) {
    const component = addressComponents.find(component => component.types.includes(t));
    if (component) {
      return component.shortText || '';
    }
  }

  return '';
};

const getDefaultAddress = () => ({
  address: '',
  apartment: '',
  city: '',
  full_address: '',
  state: '',
  zip: '',
  status: null,
  errorMessage: '',
});

const state = () => ({
  ...getDefaultAddress(),
});

const actions = {
  async setSelectedNRSDeliveryAddress({ commit }, { placePrediction }) {
    commit('CLEAR_ADDRESS_ERROR');

    const place = placePrediction.toPlace();
    await place.fetchFields({
      fields: ['addressComponents', 'formattedAddress'],
    });

    if (!place.formattedAddress) {
      return;
    }

    const address = getAddress({
      address_components: place.addressComponents,
      formatted_address: place.formattedAddress,
    });

    let statusPayload = { ...address };
    statusPayload.status = 'valid';
    statusPayload.errorMessage = '';

    commit('SET_SELECTED_ADDRESS', statusPayload);
  },
  async setSelectedMyTeamAddress({ commit }, { placePrediction }) {
    commit('CLEAR_ADDRESS_ERROR');

    const place = placePrediction.toPlace();
    await place.fetchFields({
      fields: ['addressComponents', 'formattedAddress'],
    });

    if (!place.formattedAddress) {
      return;
    }

    const address = getAddress({
      address_components: place.addressComponents,
      formatted_address: place.formattedAddress,
    });

    const straightLineDistance = placePrediction.distanceMeters;
    const isOutOfBounds = straightLineDistance > FIVE_MILES_IN_METERS;
    let statusPayload = { ...address };

    if (isOutOfBounds) {
      // case 1: invalid due to Google Maps distance check
      statusPayload.status = 'outside';
      statusPayload.errorMessage = 'Address must be within 5 miles.';
    } else {
      // case 2: valid on initial Google Maps check
      statusPayload.status = 'valid';
      statusPayload.errorMessage = '';
    }

    commit('SET_SELECTED_ADDRESS', statusPayload);
  },
};

const getters = {
  isValid(state) {
    return state.status === 'valid';
  },
  getDeliveryAddress: ({
    address,
    apartment,
    city,
    full_address,
    state,
    zip
  }) => ({ address, apartment, city, full_address, state, zip })
};

const mutations = {
  CLEAR_ADDRESS_ERROR(state) {
    state.status = null;
    state.errorMessage = '';
  },
  SET_ADDRESS_ERROR(state, { status, errorMessage }) {
    state.status = status;
    state.errorMessage = errorMessage;
  },
  SET_APARTMENT(state, apartment) {
    state.apartment = apartment;
  },
  SET_SELECTED_ADDRESS(state, payload) {
    Object.assign(state, payload);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
